import { render, staticRenderFns } from "./CompRoom.vue?vue&type=template&id=7f6f972a&scoped=true"
import script from "./CompRoom.vue?vue&type=script&lang=js"
export * from "./CompRoom.vue?vue&type=script&lang=js"
import style0 from "./CompRoom.vue?vue&type=style&index=0&id=7f6f972a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6f972a",
  null
  
)

export default component.exports